import React from 'react';

interface ColorPaletteProps {
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  fontFamily?: string;
}

export function ColorPalette({ primaryColor, secondaryColor, accentColor, fontFamily }: ColorPaletteProps) {
  const colors = [
    { label: 'Primary', color: primaryColor },
    { label: 'Secondary', color: secondaryColor },
    { label: 'Accent', color: accentColor },
  ].filter(({ color }) => color);

  if (colors.length === 0 && !fontFamily) {
    return null;
  }

  return (
    <div className="py-6 border-b border-border">
      <h3 className="text-sm font-semibold text-foreground mb-4">Visual Identity</h3>

      {colors.length > 0 && (
        <div className="flex gap-6 flex-wrap mb-4">
          {colors.map(({ label, color }) => (
            <div key={label} className="flex flex-col items-center gap-2">
              <div
                className="w-20 h-20 rounded-lg border-2 border-border shadow-sm cursor-pointer hover:scale-105 transition-transform"
                style={{ backgroundColor: color }}
                title={`Click to copy ${color}`}
                onClick={() => {
                  navigator.clipboard.writeText(color!);
                }}
              />
              <div className="text-center">
                <div className="text-xs font-medium text-foreground">{label}</div>
                <div className="text-xs font-mono text-muted-foreground">{color}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {fontFamily && (
        <div className="mt-4">
          <div className="text-xs text-muted-foreground mb-1">Font Family</div>
          <div className="text-sm font-medium text-foreground font-mono bg-muted px-3 py-2 rounded inline-block">
            {fontFamily}
          </div>
        </div>
      )}
    </div>
  );
}
